import request from '@/utils/request'

let Offline_pay_logApi = {

  /*线下付款列表*/
  list(data) {
    return request._post('/shop/plus.offline_pay_log.Index/index', data);
},
/*添加线下付款*/
add(data) {
    return request._post('/shop/plus.offline_pay_log.Index/add', data);
},
/*修改线下付款*/
edit(data) {
    return request._post('/shop/plus.offline_pay_log.Index/edit', data);
},
/*删除线下付款*/
del(data) {
    return request._post('/shop/plus.offline_pay_log.Index/del', data);
},
/*线下付款详情*/
detail(data) {
  return request._post('/shop/plus.offline_pay_log.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.offline_pay_log.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.offline_pay_log.Setting/getSetting', data, errorback);
    },
}
export default Offline_pay_logApi;



// WEBPACK FOOTER //
// ./src/api/offline_pay_log.js